module.exports = __webpack_public_path__ + "img/bepreisung_4.3d666f07.png";